export default __webpack_public_path__ + "static/media/chevron-down.6e2c90ee999455ca1ff08ddb133cf3ec.svg";